import ManageProtocoleData from '@/views/consultations/en-cours/protocole-soins/traitement-en-cours/manage-protocole-data'

export default {
    name: 'plaintes',
    components: {
        ManageProtocoleData
    },
    props: {
        user_id: Number,
        protocole_id: Number,
        hn: Number,
        plaintes: Array,
        can_start_hn: Number
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,
            data_to_add: {},

            is_error: false,
            error_message: '',
            save_loading: false,

            description: '',
            liste_plaintes: [],

            data_to_delete: {}
        }
    },

    computed: {
        protocole_plaintes() {
            return this.$store.getters['protocole_plaintes'];
        },
    },

    mounted() {
        this.getPlaintePatient()
    },

    methods: {
        addProtocoleData(data, data_id, protocole_id, hn) {
            this.data_to_add = {
                data_id: data_id,
                data_type: data,
                libelle: (data == 'plainte')?'Plainte patient':'Evènement',
                protocole_id: protocole_id,
                hn: hn
            }
        },

        refreshPlaintePatient() {
            this.is_loading = true

            const data = {
                data_type: 'plainte',
                protocole_id: this.protocole_id,
                hn: this.hn
            }

            this.$store.dispatch('getProtocoleData', data).then(() => {
                this.liste_plaintes = this.protocole_plaintes

                if (this.liste_plaintes.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }

                this.is_loading = false
            })
        },

        
        getPlaintePatient() {
            this.is_loading = true

            this.liste_plaintes = this.plaintes
            if (this.liste_plaintes.length == 0) {
                this.is_empty = true
            } else {
                this.is_empty = false
            }

            setTimeout(() => {
                this.is_loading = false
            }, 1000);
        },

        setDataToDelete(plainte) {
            this.data_to_delete = {
                user_id: this.user_id,
                protocole_id: this.protocole_id,
                id: plainte.id
            }
        }
     }
}


